<template>
  <div class="message">
    <div class="messageTitle">
      <div
        class="messageTitle_item"
        v-for="(item, index) in titleData"
        :key="index"
        :class="{ active: msgTitleType_sel == item.type }"
        @click="msgTitleType_sel = item.type"
      >
        <span>{{ item.title }}</span>
      </div>
    </div>
    <div class="listBox">
      <MessageList v-show="msgTitleType_sel == 'notice'" :list="noticeList" :showType="msgTitleType_sel"  />
      <MessageList
        v-show="msgTitleType_sel == 'strategy'"
        :list="strategyList" :showType="msgTitleType_sel" 
      />
    </div>
  </div>
</template>
<script>
import MessageList from "@/components/messageList.vue";
export default {
  name: "notice",
  components: {
    MessageList,
  },
  data() {
    return {
      userInfo: {},
      titleData: [
        {
          type: "notice",
          title: "公告",
        },
        {
          type: "strategy",
          title: "攻略",
        },
      ],
      msgTitleType_sel: "notice",
      noticeList: [],
      strategyList: [],
    };
  },
  created() {},
  mounted() {
    this.userInfo =
      localStorage.getItem("userInfo") ?
      JSON.parse(localStorage.getItem("userInfo")):{};
    this.getNotice();
    this.getStrategy();
  },
  methods: {
    getNotice() {
      let data = {
        gameId: "",
        pageNum: 1,
        pageSize: 50,
      };
      this.$api.reqData("/api/v1/index/getBulletin", data).then(
        (res) => {
          if (res.code == 200) {
            this.noticeList = res.data;
          } else {
            this.$toast.text(res.msg);
          }
        },
        (res) => {
          this.$toast.text(res.msg);
        }
      );
    },
    getStrategy() {
      let data = {
        gameId: "",
        pageNum: 1,
        pageSize: 50,
      };
      this.$api.reqData("/api/v1/index/getStrategy", data).then(
        (res) => {
          if (res.code == 200) {
            this.strategyList = res.data;
          } else {
            this.$toast.text(res.msg);
          }
        },
        (res) => {
          this.$toast.text(res.msg);
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
.message {
  height: 100%;
  @include flex_box(column, none, stretch);
  padding: 0 0.16rem;
  box-sizing: border-box;
  .messageTitle {
    @include flex_box(row, space-between, stretch);
    height: 0.68rem;
    min-height: .68rem;
  }
  .messageTitle_item {
    flex: 1;
    @include flex_box(row, center, center);
    font-size: 12px;
    color: #656565;
    border-bottom: 1px solid #fff;
    font-weight: bold;
  }
  .messageTitle_item.active {
    color: #ff913a;
    border-color: #ff913a;
  }
  .listBox{
    flex: 1;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/message.vue